import ApiConstants from '../constants/ApiConstants';
import Utility from '../utility/Utility';
import http from "../http";
import { getTenantCountryCode } from '../managers/common/CommonUtil';

export interface ComponentListAPIConfig {
    // SearchTerm?: string;
    Limit?: number;
    query?:string;
    sort_order?:string;
    currentPage?:string;
    field? :string;
    CurrentPage?: number;
    isHidden?:string;
}

const defaultConfig: ComponentListAPIConfig = {
    Limit: 20,
    currentPage: '1',
    sort_order: 'desc',
    field: '_id',
    isHidden: 'false'
};

class ComponentListService {
    static apiConfig: ComponentListAPIConfig;

    static getComponentByPage() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PEOPLE.COMPONENT+'components/tenant';
        return http
            .get(
                `${url}?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.currentPage}&sort_order=${this.apiConfig.sort_order}&sort_field=${this.apiConfig.field}&isHidden=false`
            )
            .catch((err: any) => {
                console.error('Error loading component: ', err);
                return Promise.reject(err);
            });
    }
    static getAllComponent() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PEOPLE.COMPONENT+'components/tenant?sort_order=desc&sort_field=_id&isHidden=false';
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading component: ', err);
                return Promise.reject(err);
            });
    }
    static saveComponent(param){
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PEOPLE.COMPONENT+'component';
        return http
            .post(
                url,param
            )
            .catch((err: any) => {
                console.error('Error saving component: ', err);
                return Promise.reject(err);
            });
    }
    static updateComponent(param) {
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PEOPLE.COMPONENT+'component/'+param.id;
        return http
            .put(
                url,param
            )
            .catch((err: any) => {
                console.error('Error saving component: ', err);
                return Promise.reject(err);
            });
    }
    static updateState(param,id){
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PEOPLE.COMPONENT+'component/'+id;
        return http
            .put(
                url,param
            )
            .catch((err: any) => {
                console.error('Error update state ', err);
                return Promise.reject(err);
            });
    }
    static deleteComponent(param){
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PEOPLE.COMPONENT+'components/bulk';
        return http
            .delete(url,{data:param})
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }

    static getTotalComponent(){
        const url = ApiConstants.URL.PEOPLE.COMPONENT +'components/tenant';
        return http.get(
            `${url}?isHidden=false&sort_order=desc&sort_field=_id`
        )
    }
    static getComponentCategory() {
        const url = ApiConstants.URL.COMPLIANCE.COMPONENT.GET(getTenantCountryCode());
        return http.get(
            `${url}`
        )
    }
}

export default ComponentListService;
